// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w9BC","tabsBox":"styles_tabsBox__ROZ1Z","createButton":"styles_createButton__-j1zD"};